import React from "react";
import { IconButton } from "@mui/material";
import LogoutIcon from "@mui/icons-material/Logout";
import { useDispatch } from "react-redux";
import { logout } from "../../../logout";

const LogoutButton = () => {
  const dispatch = useDispatch();
  const handleLogout = () => {
    dispatch(logout());
  };
  return (
    <IconButton onClick={handleLogout} size="small" sx={style.button}>
      <LogoutIcon sx={style.logo} />
    </IconButton>
  );
};

export default React.memo(LogoutButton);

const style = {
  button: {
    width: "40px",
    height: "40px",
    border: "1px solid #E9EAEB",
    borderRadius: "50%",
    backgroundColor: "white",
    "&:hover": {
      backgroundColor: "#F5F5F5",
    },
  },
  logo: { color: "#F97066", fontSize: "20px" },
};
